export const COMPONENTS_API_TAGS = {
  COMPONENT_TAG: 'Component',
  COMPONENTS_LIST_TAG: 'ComponentsList',
};
